import { Link } from "react-router-dom";
import type { Review } from "@/mocks/reviews";

interface ReviewCardProps {
  review: Review;
  layout?: "vertical" | "horizontal";
}

export default function ReviewCard({ review, layout = "vertical" }: ReviewCardProps) {
  if (layout === "horizontal") {
    return (
      <Link
        to={`/special#${review.id}`}
        className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3.5 hover:border-primary-300 transition-colors cursor-pointer"
      >
        <div className="w-28 h-20 md:w-36 md:h-24 shrink-0 rounded-md overflow-hidden bg-background-200">
          <img
            src={review.cover}
            alt={`${review.title} 配图`}
            title={`${review.title}·影评分析`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="min-w-0 flex flex-col">
          <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {review.title}
          </h3>
          <p className="mt-1.5 text-xs leading-5 text-foreground-600 line-clamp-2 hidden sm:block">
            {review.excerpt}
          </p>
          <div className="mt-auto pt-2 flex items-center gap-2 text-[11px] text-foreground-500">
            <i className="ri-user-line" />
            <span>{review.author}</span>
            <span className="w-px h-3 bg-background-300" />
            <span>{review.date}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/special#${review.id}`}
      className="group flex flex-col rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-200">
        <img
          src={review.cover}
          alt={`${review.title} 配图`}
          title={`${review.title}·影评分析`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute bottom-2.5 left-2.5 rounded-full bg-accent-500 px-2.5 py-0.5 text-[11px] font-medium text-background-50">
          深度影评
        </span>
      </div>
      <div className="flex flex-col flex-1 p-4">
        <h3 className="font-heading text-base font-semibold text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {review.title}
        </h3>
        <p className="mt-2 text-xs leading-5 text-foreground-600 line-clamp-3">{review.excerpt}</p>
        <div className="mt-auto pt-3 flex items-center gap-2 text-[11px] text-foreground-500">
          <i className="ri-user-line" />
          <span>{review.author}</span>
          <span className="w-px h-3 bg-background-300" />
          <span>{review.date}</span>
        </div>
      </div>
    </Link>
  );
}